/*eslint-disable*/
export const messages = {
  "Cancel": "Annuler",
  "Change theme": "Changer de thème",
  "Clear chat": "Effacer la conversation",
  "Clear chat history": "Effacer l'historique de conversation",
  "Connecting...": "Connexion en cours...",
  "Continue": "Continuer",
  "Decrease font size": "Réduire la taille de police",
  "Disclaimer": "Avertissement",
  "Enter your message...": "Saisissez votre message...",
  "Type your message...": "Saisissez votre message...",
  "Error": "Erreur",
  "Font size": "Taille de police",
  "Increase font size": "Augmenter la taille de police",
  "Language": "Langue",
  "MJ Lab": "Laboratoire MJ",
  "Reset font size": "Réinitialiser la taille de police",
  "Respond time: {time}s": "Temps de réponse : {time}s",
  "Response time:": "Temps de réponse :",
  "Send": "Envoyer",
  "Settings": "Paramètres",
  "Support the project": "Soutenir le projet",
  "System": "Système",
  "Theme": "Thème",
  "Thinking...": "Réflexion en cours...",
  "Toggle theme": "Basculer le thème",
  "Welcome to {{name}} by MJ": "Bienvenue sur {{name}} par MJ",
  "You asked:": "Vous avez demandé :",
  
  // Headers
  "Labor Law Expert": "Expert en droit du travail",
  "by MJ": "par MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Bonjour, je suis {{name}}, un assistant IA créé par MJ.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "Je suis expert en droit du travail et réglementations de l'Arabie Saoudite.",
  "Ask me a question, and I will gladly answer you.": "Posez-moi une question, et je vous répondrai avec plaisir.",
  "Do not share confidential data.": "Ne partagez pas de données confidentielles.",
  "I am powered using": "Je suis propulsé par",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Avertissement :** {{name}} est un assistant IA expérimental conçu pour répondre en utilisant des données issues des lois et réglementations du travail saoudiennes, évitant les suppositions ou inexactitudes. Je ne suis pas responsable de son comportement ou de l'exactitude de ses réponses.",
  
  // Frameworks
  "Automatic detection": "Détection automatique",
  "Labor Law": "Droit du travail",
  "Saudization": "Saoudisation",
  "Contracts": "Contrats",
  "Termination": "Résiliation",
  "Wages & Benefits": "Salaires et avantages",
  "Leave Policies": "Politiques de congés",
  "Workplace Safety": "Sécurité au travail",
  
  // Models
  "Claude by Anthropic": "Claude par Anthropic",
  "DeepSeek by Groq": "DeepSeek par Groq",
  "MJ Lab Mode": "Mode Laboratoire MJ",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} caractère restant",
  "{{remainingChars}} characters left": "{{remainingChars}} caractères restants",
  
  // Error messages
  "An error occurred": "Une erreur s'est produite",
  "Failed to change language": "Échec du changement de langue",
  "Please try again": "Veuillez réessayer",
  "Connection lost": "Connexion perdue",
  "Reconnecting...": "Reconnexion en cours...",
  "Nothing to clear": "Rien à effacer",
  "All messages cleared": "Tous les messages ont été effacés",
  "All data cleared": "Toutes les données ont été effacées",
  "Storage limit reached": "Limite de stockage atteinte",
  "Some older messages were removed to save space.": "Certains messages plus anciens ont été supprimés pour économiser de l'espace.",
  
  // Additional keys
  "Font Size": "Taille de police",
  "Language changed to {locale}": "Langue changée en {locale}",
  "Select language": "Sélectionner la langue",
  "Support": "Support",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "Message copié dans le presse-papiers",
  "Read": "Lire",
  "Summarize": "Résumer",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Suggestions de messages",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Sélectionnez une question pour démarrer rapidement une conversation sur les lois du travail saoudiennes.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "Quels sont les principaux droits des employés selon le droit du travail saoudien ? Pouvez-vous me donner un aperçu simple ?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "Quelles sont les obligations de l'employeur concernant les heures de travail, les heures supplémentaires et les congés en Arabie Saoudite ?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "Comment le droit du travail saoudien gère-t-il la cessation d'emploi et les indemnités de fin de service ?",
  
  // Audio Player Dialog
  "AI Summary": "Résumé IA",
  "Listen to the summarized response using our AI Service.": "Écoutez la réponse résumée grâce à notre service d'IA.",
  "Generating summary...": "Génération du résumé...",
  "Preparing audio...": "Préparation de l'audio...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Échec du traitement du texte. Veuillez réessayer.",
  "Failed to auto-play audio. Click play to try again.": "Échec de la lecture automatique de l'audio. Cliquez sur lecture pour réessayer.",
  "Failed to load audio. Please try again.": "Échec du chargement de l'audio. Veuillez réessayer.",
  "Audio playback was aborted.": "La lecture audio a été interrompue.",
  "Network error occurred while loading audio.": "Une erreur réseau s'est produite lors du chargement de l'audio.",
  "Audio decoding failed.": "Échec du décodage audio.",
  "Audio format not supported.": "Format audio non pris en charge.",
  "Failed to setup audio playback": "Échec de la configuration de la lecture audio",
  "Failed to generate speech": "Échec de la génération de la parole",
  "Failed to generate audio. Please try again.": "Échec de la génération audio. Veuillez réessayer.",
  "Failed to play audio. Please try again.": "Échec de la lecture audio. Veuillez réessayer.",
  
  // Update Notifications
  "update.updateAvailable": "Mise à jour disponible",
  "update.newVersionAvailable": "Nouvelle version {{version}} disponible",
  "update.refreshToApply": "Actualisez pour appliquer les dernières fonctionnalités et améliorations",
  "update.later": "Plus tard",
  "update.updateNow": "Mettre à jour maintenant",
  
  // CSAT Feedback
  "We Value Your Feedback": "Votre avis nous intéresse",
  "Give Feedback": "Donner un avis",
  "How would you rate your experience?": "Comment évalueriez-vous votre expérience ?",
  "Very Dissatisfied": "Très insatisfait",
  "Dissatisfied": "Insatisfait",
  "Neutral": "Neutre",
  "Satisfied": "Satisfait",
  "Very Satisfied": "Très satisfait",
  "Select a rating": "Sélectionnez une note",
  "Comments or Bug Report": "Commentaires ou signalement de bug",
  "Please share your thoughts or report any issues...": "Partagez vos réflexions ou signalez des problèmes...",
  "Contact Number": "Numéro de contact",
  "Feedback Type": "Type de commentaire",
  "Select a feedback type": "Sélectionnez un type de commentaire",
  "Loading...": "Chargement...",
  "No feedback types available": "Aucun type de commentaire disponible", 
  "(Optional)": "(Facultatif)",
  "Feedback Submitted": "Commentaire envoyé",
  "Thank you for your feedback!": "Merci pour votre commentaire !",
  "Rating Required": "Évaluation requise",
  "Please select a rating before submitting.": "Veuillez sélectionner une note avant de soumettre.",
  "Submit Feedback": "Envoyer le commentaire",
  "Submitting...": "Envoi en cours...",
  "General": "Général",
  "Bug": "Bug",
  "Idea": "Idée",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Tableau de bord des commentaires",
  "Total Feedbacks": "Total des commentaires",
  "All-time submissions": "Soumissions de tous les temps",
  "Average Rating": "Note moyenne",
  "Out of 5 stars": "Sur 5 étoiles",
  "Feedback with Comments": "Commentaires avec texte",
  "Detailed feedback": "Commentaires détaillés",
  "Rating Distribution": "Distribution des notes",
  "Breakdown of user satisfaction": "Répartition de la satisfaction des utilisateurs",
  "Rating Percentage": "Pourcentage des notes",
  "Proportion of each rating": "Proportion de chaque note",
  "Responses": "Réponses",
  "All Feedback": "Tous les commentaires",
  "Detailed view of user submissions": "Vue détaillée des soumissions des utilisateurs",
  "ID": "ID",
  "Rating": "Note",
  "Comment": "Commentaire",
  "Contact": "Contact",
  "Date": "Date",
  "Page": "Page",
  "No feedback data available": "Aucune donnée de commentaires disponible",
  "No comment": "Pas de commentaire",
  "Not provided": "Non fourni",
  "Not available": "Non disponible",
  
  // Authentication
  "Login": "Connexion",
  "Register": "S'inscrire",
  "Username": "Nom d'utilisateur",
  "Password": "Mot de passe",
  "Confirm Password": "Confirmer le mot de passe",
  "Email": "Email",
  "Full Name": "Nom complet",
  "Don't have an account?": "Vous n'avez pas de compte ?",
  "Already have an account?": "Vous avez déjà un compte ?",
  "Login to continue": "Connectez-vous pour continuer",
  "Create an account": "Créer un compte",
  "Passwords must match": "Les mots de passe doivent correspondre",
  "Invalid email": "Email invalide",
  "Required": "Obligatoire",
  "Unauthorized": "Non autorisé",
  "You don't have permission to access this page.": "Vous n'avez pas l'autorisation d'accéder à cette page."
};